import { useMutation, gql } from '@apollo/client';
import {
  EditarUnidadeMutation,
  EditarUnidadeMutationVariables,
} from './__generated__/EditarUnidadeMutation';

const EDITAR_HORARIO_MUTATION = gql`
  mutation EditarUnidadeMutation($id_unidade: Int!, $dsc_nome_unidade: String) {
    editarUnidade(input: { id_unidade: $id_unidade, dsc_nome_unidade: $dsc_nome_unidade }) {
      id_unidade
      dsc_nome_unidade
    }
  }
`;

const useEditarUnidadeMutation = () => {
  return useMutation<EditarUnidadeMutation, EditarUnidadeMutationVariables>(
    EDITAR_HORARIO_MUTATION
  );
};

export { useEditarUnidadeMutation };
